module.exports = __webpack_public_path__ + "static/img/wechatSmallPro.55be8beb.png";